module.exports = __webpack_public_path__ + "static/media/More.f5369324.svg";